/**
 * Функция для получения стилей цветной плашки на фото прогулки
 * @param data строка с тегом и стилями из админки
 * @returns массив с иформацией о теге
 */
export default function getTagStylesFromTag(
  data: string
): RegExpExecArray | [] {
  const regExp = /\[(.+?)\]\((.+?)\)\{(.+?)\}/;

  const res = regExp.exec(data);
  if (res) {
    return res;
  } else return [];
}
